export const SUPPORTED_COUNTRIES = ['US', 'CA', 'AU', 'GB', 'NZ'] as const;

type SupportedCountryType = (typeof SUPPORTED_COUNTRIES)[number];

export const isSupportedCountry = (
  country: string,
): country is SupportedCountryType =>
  SUPPORTED_COUNTRIES.includes(country as SupportedCountryType);
